import fp from 'lodash/fp'

const SIZES = ['xs', 'sm', 'md', 'lg']
const OFFSET_SIZES = SIZES.map((size) => `${size}Offset`)
const COLUMN_PROPS = [...SIZES, ...OFFSET_SIZES]
const ALIGNMENT = ['start', 'end', 'center', 'top', 'bottom', 'middle']
const DISTRIBUTION = ['around', 'between']
const ROW_PROPS = [...ALIGNMENT, ...DISTRIBUTION]

const getColumnReorderingClassName = (props) => {
  const classes = []

  if (fp.includes(props.last, SIZES)) {
    classes.push(`last-${props.last}`)
  }

  if (fp.includes(props.first, SIZES)) {
    classes.push(`first-${props.first}`)
  }

  return classes.join(' ')
}

export const getRowClassName = (props) => {
  const classes = []

  if (props.className) {
    classes.push(props.className)
  }

  if (props.reverse) {
    classes.push('reverse')
  }

  for (const prop of ROW_PROPS) {
    const propValue = props[prop]

    if (!fp.includes(propValue, SIZES)) {
      continue
    }

    classes.push(`${prop}-${propValue}`)
  }

  return classes.join(' ')
}

export const getColumnClassName = (props) => {
  const classes = []

  for (const prop of COLUMN_PROPS) {
    const propValue = props[prop]

    if (!propValue) {
      continue
    }

    const hypenizedProp = fp.kebabCase(prop)

    const cls = fp.isNumber(propValue)
      ? `col-${hypenizedProp}-${propValue}`
      : `col-${hypenizedProp}`

    classes.push(cls)
  }

  classes.push(getColumnReorderingClassName(props))

  return classes.join(' ')
}
